module.exports = __webpack_public_path__ + "img/cloud-bolt.a77a14e2.svg";